import React, { RefObject } from 'react';

import Icon from 'carbon-react/lib/components/icon';

import { TreeDragDropHandlers } from './useTreeDragDrop';

interface DragHandleProps {
  drag: TreeDragDropHandlers;
  index: number;
  rowRef: RefObject<HTMLElement | null>;
  /** Uses the first table cell, including its full row height, as the native drag preview. */
  useFirstColumnDragImage?: boolean;
  disabled?: boolean;
  className?: string;
}

export const DragHandle = ({ drag, index, rowRef, useFirstColumnDragImage, disabled, className }: DragHandleProps) => (
  <div
    data-testid="drag-handle"
    className={className}
    draggable={!disabled}
    onDragStart={(e: React.DragEvent<HTMLDivElement>) => {
      drag.onDragStart(index);
      e.dataTransfer.effectAllowed = 'move';
      if (rowRef.current) {
        const firstColumn = rowRef.current.firstElementChild as HTMLElement | null;
        const dragImage = useFirstColumnDragImage ? firstColumn || rowRef.current : rowRef.current;
        // eslint-disable-next-line no-magic-numbers
        e.dataTransfer.setDragImage(dragImage, 20, 20);
      }
    }}
    onDragEnd={drag.onDragEnd}
    onClick={e => e.stopPropagation()}
    style={{ display: 'flex', alignItems: 'center', cursor: disabled ? 'not-allowed' : 'grab', height: '20px' }}
  >
    <Icon type="drag" fontSize="small" />
  </div>
);
